
/**跟新Exam状态 的通用组件： 
 * 
 * @param {检查id} examUuid 
 * @param {检查状态：目标状态} state 
 * @param {更新状态的service} service 
 * @param {重新获取列表} reGetList 
 * @param {消息插件} message 
 */
export const Util_updateExamState = (examUuid, state, service, reGetList , message ) => {
  // let params = `${examUuid}"/"${state}`;
  let params = examUuid + "/" + state;
  service(params)
    .then((res) => {
      if (res.success) {
        reGetList();
        message({ message: res.description, type: "success" });
      } else {
        message({ message: res.description, type: "error" });
      }
    })
    .catch((e) => {
      console.log(e);
    });
};

export const deviceType = () => {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  if(isiOS){
      return "ios"
  }else if(isAndroid){
      return 'android'
  }
}

export const formatText = (text)=>{
  return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ')
}

export const isIOS = () => {
  let u = navigator.userAgent;
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
}
